import { toast } from 'react-toastify';
import { Check, X } from 'lucide-react';
import VerifyOtp from '../resetPassword/VerifyOtp';
import { useRef, useEffect, useState } from 'react';
import { useMutation } from '@tanstack/react-query';
import { useSendOTP } from '../../hooks/useSendOTP';
import { Controller, useForm } from 'react-hook-form';
import { VerifyEmailInner } from './VerifyEmailInner';
import { passwordResetOTPVerification } from '../../api/authAPI';
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom';

export const VerifyEmail = () => {
  const { email } = useParams();
  const decodedEmail = decodeURIComponent(email);

  const [verified, setVerified] = useState(null);

  return (
    <div>
      <header className="flex-1 py-6 px-5 flex flex-col items-start lg:pl-36">
        <div className="w-full flex justify-center lg:justify-end">
          <Link to="/" aria-label="SmallSmall Home">
            <img
              src="/images/SST_LOGO_HORIZONTAL_WEB_DARK.svg"
              alt="SmallSmall Logo"
              width={120}
              height={40}
              loading="eager"
              decoding="async"
            />
          </Link>
        </div>
      </header>

      <section className="px-5 md:w-[480px] mx-auto grid gap-3">
        <h1 className="font-bold text-[25px] font-duplet">
          Verify your email address
        </h1>
        <p className="text-xs text-[#96959F]">
          Enter the code sent to <span className="text-black">{email}</span> to
          verify your email address.
        </p>

        <VerifyEmailInner
          verified={verified}
          setVerified={setVerified}
          email={email}
        />
      </section>
    </div>
  );
};
